import { render, staticRenderFns } from "./SpecialOfferList.vue?vue&type=template&id=0a802813"
import script from "./SpecialOfferList.vue?vue&type=script&lang=js"
export * from "./SpecialOfferList.vue?vue&type=script&lang=js"
import style0 from "./SpecialOfferList.vue?vue&type=style&index=0&id=0a802813&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports